import * as users from "./api/users";
import * as storageKeys from "../enums/storageKeys";

export const PROFILE_BINDER_KEY_ROOT = "profile-";

export function getProfileBinderKey(libraryName, binderType, id) {
	return `${PROFILE_BINDER_KEY_ROOT}${libraryName}-${binderType}-${id}`;
}

export function getBinderWallFilterKey(libraryName) {
	return `${libraryName}${storageKeys.BINDER_FILTERS}`;
}

export function getBinderWallSortOrderKey(libraryName) {
	return `${libraryName}${storageKeys.BINDER_SORT_ORDER}`;
}

export function getGroupKey(groupId) {
	return `${users.GROUP_KEY_ROOT}${groupId}`;
}
